import { Link } from '@tanstack/react-router';
import clsx from 'clsx';
import type { ReactNode } from 'react';

export type DeviceLinkProps = {
  installationId: string;
  nickname?: string | null;
  /**
   * - `auto` — nickname when set, otherwise first 8 of installation id
   * - `nickname` — nickname or em dash
   * - `id` — full installation id (mono)
   * - `short` — first 8 of installation id (mono)
   */
  label?: 'auto' | 'nickname' | 'id' | 'short';
  className?: string;
  children?: ReactNode;
};

function defaultLabel(
  installationId: string,
  nickname: string | null | undefined,
  label: DeviceLinkProps['label']
): string {
  if (label === 'id') return installationId;
  if (label === 'short') return installationId.slice(0, 8);
  if (label === 'nickname') return nickname ?? '—';
  return nickname ?? installationId.slice(0, 8);
}

export function DeviceLink({
  installationId,
  nickname,
  label = 'auto',
  className,
  children,
}: DeviceLinkProps) {
  const text = children ?? defaultLabel(installationId, nickname, label);
  const mono =
    children == null &&
    (label === 'id' || label === 'short' || (label === 'auto' && !nickname));

  return (
    <Link
      to="/admin/devices/$installationId"
      params={{ installationId }}
      title={installationId}
      className={clsx(
        'text-primary hover:underline',
        mono && 'font-mono text-xs',
        className
      )}
    >
      {text}
    </Link>
  );
}
